














































































































import Vue from 'vue'
import * as dateFormat from 'dateformat'
import { countryCodes } from '@/countryCodes'
import gql from 'graphql-tag'

export default Vue.extend({

  data() {
    return {
      loading: false,
      auditsForBatch: null,
      dateFormat: dateFormat,
      resultsPerPage: 10,
      currentPage: 1,
      showFilter: true,
      filterString: '',
      companyId: null,
      currentCountry: null,
      countryCodes,
    }
  },

  watch: {
    currentPage() {
      this.loadAuditsForBatch()
    },
  },

  computed: {
    loadingAudits() {
      return this.$apollo.loading || ! this.auditsForBatch || ! this.auditsForBatch.items
    },
  },

  methods: {

    async loadAuditsForBatch() {
      this.auditsForBatch = null
      const { data: { auditsForBatch } } = await this.$apollo.query({
        query: gql`query BatchlessAudits(
          $perPage: Float!,
          $page: Float!,
          $queryString: String,
          $companyId: String,
          $countryCode: String
          $onlyCompleted: Boolean
        ) {
          auditsForBatch(
            page: $page 
            perPage: $perPage 
            queryString: $queryString
            companyId: $companyId
            countryCode: $countryCode
            onlyCompleted: $onlyCompleted
          ) {
            pageInfo {
              currentPage
              perPage
              pageCount
              itemCount
              hasNextPage
              hasPreviousPage 
            }
            items {
              id
              batch {
                id
                owner {
                  email
                  name
                  company {
                    name
                  }
                }
                name
                description
                csv
                startedAt
                finishedAt
                numLinks
                numCurrentCompletedAudits
                isDone
              }
              awsInstanceId
              order
              status
              assessmentStatus {
                id
                narrative
                statusType
              }
              assignedTo {
                id
                name
              }
              link
              name
              proxy
              placement
              userDefinedNetwork
              userDefinedMerchant
              detectedCmpId
              detectedCmp {
                name
              }
              tags
              failReason
              auditTime
              auditedAt
              network
              advertiser {
                id
                networkId
                advertiserId
                name
                domain
                primaryTrackingMethod
                trackingMethodNarrative
                javascript
                s2s
                other
                bespokeCookieValueType
                bespokeCookieName
                bespokeCookieValue
                bespokeAni
                bespokeMasterTag
                internalComment
                publicComment
                cannotAudit
                cannotAuditReason
                whitelistRequest {
                  id
                  whitelistActive
                }
              }
              advertiserSnapshot
              inferredNetworkVariables
              moonpullErrors
              cookiesWereAccepted
              internalErrorObj
              handoverImpact
              handoverImpactPostConsent
              handoverImpactPostConsentRefresh
              hasPostConsentJourney
              hasPostConsentRefreshJourney
              closedMerchant
              outdated
              inferredS2S
              finalDomain
              csvOverrideCookieType
              csvOverrideCookieName
              csvOverrideCookieValue
              csvOverrideAni
              csvOverrideMasterTag
              aniTruncated
              interstitialNavigated
              noAccess
              proxyDetails
              manualReviewRequired
              hasAlp
              hasAlpPostConsent
              hasAlpPostConsentRefresh
              isRetry
              useDataCentre
              countryCode
              batchLink {
                postAlpURL
                skipConsent
                puppeteerFlags
              }
              isChangedFromComparison
              nextComparisonAudit {
                id
                auditedAt
                memoryCookieStatus
                isChangedFromComparison
              }
              previousComparisonAudit {
                id
                auditedAt
                memoryCookieStatus
                isChangedFromComparison
              }
              memoryCookieStatus
              memoryCookieStatusReadable
              screenshots {
                id
                screenshotUrl
              }
            }
          }
        }`,

        variables: {
          perPage: this.resultsPerPage,
          page: this.currentPage,
          queryString: this.filterString,
          companyId: this.companyId,
          countryCode: this.currentCountry,
          onlyCompleted: true,
        },
      })
      this.auditsForBatch = auditsForBatch
    },

    getAlpDomain(audit) {
      return audit.finalDomain || 'None found'
    },

    generateScreenshotUrl(key) {
      return `https://d30bc2nkwjetgt.cloudfront.net/${key}`
    },

    getCurrentScreenshot(stage) {
      const screenshot = this.auditData.screenshots.find(s => s.stage === stage)
      if (! screenshot) {
        return 'None found'
      }
      return this.generateScreenshotUrl(screenshot.screenshotUrl)
    },

    getAuditMemoryCookieStatusLabel(status) {
      if (status === 'IMMEDIATE') return 'badge badge-primary';
      else if (status === 'CONDITIONAL_ON_CMP') return 'badge badge-warning'
      else if (status === 'CONDITIONAL_ON_CMP_AND_REFRESH') return 'badge badge-warning'
      else if (status === 'NO_MEMORY_COOKIE') return 'badge badge-danger'
      else if (status === 'CLOSED_ADVERTISER') return 'badge badge-secondary'
      else if (status === 'NOT_AUDITED') return 'badge badge-secondary'
      else if (status === 'MANUAL_REVIEW') return 'badge badge-secondary'
      else if (status === 'OTHER') return 'badge badge-secondary'
      
      return 'badge badge-secondary';
    },

    getTrackingMatrix(audit) {
      if (audit.memoryCookieStatus === 'MANUAL_REVIEW' || audit.memoryCookieStatus === 'CLOSED_ADVERTISER') {
        return ''; // Return an empty string for specified audit statuses
      }

      const stages = [
        { name: 'alp', flag: 'hasAlp' },
        { name: 'alp-post-consent', flag: 'hasAlpPostConsent' },
        { name: 'alp-post-consent-refresh', flag: 'hasAlpPostConsentRefresh' }
      ];

      const errorStatuses = stages.map(({ name, flag }) => {
        // Check if the audit has the stage based on the flag
        if (!audit[flag]) {
          return ''; // Skip processing if the audit does not have this stage
        }

        const errorPrefix = 
          (name === 'alp') ? '5' :
          (name === 'alp-post-consent') ? '6' :
          (name === 'alp-post-consent-refresh') ? '7' : null;

        if (!errorPrefix || !audit.moonpullErrors) {
          return 'N/A';
        }

        const networkErrors = this.networkErrorCodes.find(n => n.network === audit.network);
        const isErrorPresent = errorCode => audit.moonpullErrors.find(e => e.moonpullErrorId === `${errorPrefix}.${errorCode}`);

        const statusForErrorCode3 = networkErrors && networkErrors.errorCodes.includes(`${errorPrefix}.3`) ? isErrorPresent('3')  ? 'N' : 'OK' : 'N/A';
        const statusForErrorCode4 = audit.cmpId === null && errorPrefix !== '5' ? '-' : isErrorPresent('4') ? 'N' : 'OK';
        const statusForErrorCode5 = (audit.cmpId === null && errorPrefix !== '5') || isErrorPresent('4') ? '-' : isErrorPresent('5') ? 'N' : 'OK';

        // For simplicity, this example just returns the status for error code 3.
        // Adjust your logic here if you need to check for stage applicability based on audit properties.
        return statusForErrorCode3;
      });

      // Filter out empty strings to avoid displaying them, if necessary.
      return errorStatuses.filter(status => status !== '').join(' ');
    },

    auditLink(audit) {
      return {
        name: 'report-detail-output',
        params: {
          batchIds: this.$route.params.batchIds,
          auditId: audit.id,
          view: this.view
        }
      }
    },

    onCompanyInput(e){
      this.companyId = e
    },

    toggleDropdown(audit) {

      // Toggle all other audits dropdown off
      this.auditsForBatch.items.forEach(a => {
        if (a.id !== audit.id) {
          a.showDropdown = false
        }
      })
      
      // Toggle dropdown status for this audit
      audit.showDropdown = ! audit.showDropdown

      // Hack to force rerender of array
      this.auditsForBatch.items = [ ...this.auditsForBatch.items ]
    },

  },

  async mounted() {
    this.networks = await this.$moonpull.getNetworks()
    this.networkErrorCodes = this.networks.map(network => {
      const errorCodes = []
      const stages = [ 'niu', 'nir', 'air', 'alp', 'alp-post-consent', 'alp-post-consent-refresh' ]
      stages.forEach(stage => {
        if (network.successCriteria[stage]) {
          if (network.successCriteria[stage].query) {
            errorCodes.push(...network.successCriteria[stage].query.map(q => [ q.moonpullErrorCodeForKey, q.moonpullErrorCodeForValue ]).flat())
          }
          if (network.successCriteria[stage].cookies) {
            errorCodes.push(...network.successCriteria[stage].cookies.map(q => [ q.moonpullErrorCodeForKey, q.moonpullErrorCodeForValue ]).flat())
          }
          if (network.successCriteria[stage].scripts) {
            errorCodes.push(...network.successCriteria[stage].scripts.map(q => q.moonpullErrorCode))
          }
          if (network.successCriteria[stage].extracted) {
            errorCodes.push(...network.successCriteria[stage].extracted.map(q => q.moonpullErrorCode))
          }
        }
      })
      return {
        network: network.name,
        errorCodes
      }
    })
    await this.loadAuditsForBatch()
  },
})
